<template>
    <div>
      <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>后台管理</el-breadcrumb-item>
    <el-breadcrumb-item>老师听课记录</el-breadcrumb-item>
  </el-breadcrumb>
  
  <el-card>
    <el-row :gutter='10'>
      <el-col :span="1.5"><p  class="lableforP" > 讲课人：</p></el-col>
      <el-col :span="2"><el-input v-model="teacher" @keyup.enter.native="VileaDate"></el-input></el-col>
      <el-col :span="1.5" :offset="1"><p class="lableforP" > 听课人：</p></el-col>
      <el-col :span="2"><el-input v-model="lecturesUser"  @keyup.enter.native="VileaDate"></el-input></el-col>
    <!-- </el-row> -->
      <el-col :span="2" :offset="1"><el-button type="primary" @click="VileaDate">查询</el-button></el-col>
      <el-col :span="3"> <p class="lableforSearch">查询到{{lecturesList.length}}条数据</p></el-col>
    </el-row>
  <el-table
  :data="lecturesList"
  border
      style="width: 100%"
  >
      <el-table-column
        prop="teacher"
        width="120"
        label="授课教师">
      </el-table-column>
      <el-table-column
        prop="lecturesUser"
        label="听课人"
        width="200"
        :show-overflow-tooltip="true"
       >
      </el-table-column>
       <el-table-column
        prop="courseTitle"
        :show-overflow-tooltip="true"
        label="课程名称"
        width="180">
      </el-table-column>
       <el-table-column
        prop="courseType"
        :show-overflow-tooltip="true"
        label="课程类型"
        width="180">
      </el-table-column>
  
       <el-table-column
        prop="lecturesAddress"
        label="授课地点"
        width="180"
        >
      </el-table-column>
       <el-table-column
        prop="lecturesContent"
        label="课程主要内容"
        width="180">
      </el-table-column>
  
  
      <el-table-column
        prop="section"
        label="节次"
        width="180">
      </el-table-column>
      <el-table-column
        prop="lecturesClass"
        label="授课班级"
        width="180">
      </el-table-column>
      <el-table-column
        prop="username"
        label="提交账户"
        width="180">
      </el-table-column>
      <el-table-column
        label="操作"
        width="190"
       >
        <template slot-scope="scope">
          <el-button   @click="getLec(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <el-dialog
    :visible.sync="dialogVisible"
    width="90%"
   >
  <ViewLectures :formInline="formInline"></ViewLectures>
  <el-button type=" primary" @click="dialogVisible=false">取消</el-button>
  </el-dialog>
  </div>
    </div>
  </template>
  
  <script>
     import ViewLectures from '@/components/work/teacher/ViewLectures.vue'
  export default {
    components:{ViewLectures},
  data(){
      return{
         teacher:'',
         lecturesUser:'',
          lecturesList:[],
          dialogVisible:false,
          formInline:{},
          List2:[],
          List3:[],
      }
  },
  created(){
      this.getLectures()
  },
  methods:{
      getLectures(){
          
  this.axios.post("/lectures/getLectures?username="+JSON.parse(localStorage.getItem('user')).username)
          .then((resp) => {
            if (resp.data.status == 1) {
              console.log(resp.data.result)
            this.lecturesList=resp.data.result
            } else {
              alert("拿取数据失败");
            }
          })
          .catch((err) => {
            this.$message.error("出错");
          });
      },VileaDate(){
          if(this.List2.length<=0){
            this.List2=this.lecturesList
          }
          this.lecturesList=this.List2
          this.lecturesList=this.lecturesList.filter((item)=>{
           if(this.teacher!=''){
            return this.teacher==item.teacher
           }else{
            return true
           }     
  
          })
          this.lecturesList=this.lecturesList.filter((item)=>{
            if(this.lecturesUser!=''){
              return this.lecturesUser==item.lecturesUser
           }else{
            return true
           }
          })
        
      },
      getLec(data){
        this.dialogVisible=true
        this.formInline=data
      }
  }
  }
  </script>
  
  <style scoped>
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .lableforP{
      margin-top:8px;

    }
 .lableforSearch{
      margin-top:8px;
      color:grey
}
  
  
  </style>
  


// WEBPACK FOOTER //
// src/components/work/teacher/ViewTeahcherLectures.vue